module.exports = __webpack_public_path__ + "static/psychology_ux-1d6322134ce3cbf1353eac6013519309.png";